// Tiny helper: a CTA is "live" only when it carries a non-empty URL.
// Components use this to hide booking / register buttons when the API has
// not supplied a real URL yet (e.g. booking page not published).
import type { PaCta } from "@/types/content";

export function hasCta(cta: PaCta | undefined | null): cta is PaCta {
  if (!cta) return false;
  const url = (cta.url ?? "").trim();
  const label = (cta.label ?? "").trim();
  if (!url || !label) return false;
  // "#" alone is not a destination.
  if (url === "#") return false;
  return true;
}
